import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["ui--dialog"];

  open(event) {
    event.preventDefault();
    if (this.hasUiDialogOutlet) {
      this.uiDialogOutlet.openBy(event.target);
    }
  }
}
